import { TablePagination } from '@sanlam-glacier/app-common/components';
import { useState } from 'react';
import { Regulation28ClientCard } from './Regulation28ClientCard';
import styles from './regulation-28-card-view.module.scss';
import { Reg28ClientBreachesResponseModelMock } from '../../../types/regulation-28/regulation-28.interfaces';

export const Regulation28CardView = ({
  entries
}: {
  entries: Reg28ClientBreachesResponseModelMock[];
}) => {
  const testComponentName = 'regulation28CardView';
  const [pageSize, setPageSize] = useState(6);
  const [page, setPage] = useState(0);

  const paginatedData = entries.slice(page * pageSize, page * pageSize + pageSize).reverse();
  return (
    <>
      <div className={styles.cardsContainer} data-testid={`${testComponentName}Container`}>
        {paginatedData.map((row) => (
          <Regulation28ClientCard key={`${row.clientId}${row.exposureBreaches}`} row={row} />
        ))}
      </div>
      <TablePagination
        data-testid={`${testComponentName}Pagination`}
        className={styles.tableFooter}
        count={entries.length}
        rowsPerPage={pageSize}
        page={page}
        onPageChange={(newPage: number) => setPage(newPage)}
        onRowsPerPageChange={(newPageSize: number) => {
          setPage(0);
          setPageSize(newPageSize);
        }}
        rowsPerPageOptions={[6, 12, 18, 24]}
        closeMenuOnSelection
        showLabels={false}
      />
    </>
  );
};
